module.exports = __webpack_public_path__ + "static/media/iconTotalQuestionPost.adc1893c.svg";